import { createTheme } from '@mui/material/styles';
import { Theme as EmotionTheme } from '@emotion/react';
import { Theme as MuiTheme } from '@mui/material';

const palette: MuiTheme = createTheme({
  palette: {
    text: { primary: '#3C3C3C' },
    mode: 'light',
    background: {
      default: '#ffffff',
    },
    primary: {
      main: '#158E50',
      contrastText: '#ffffff',
      dark: '#0D542F',
      light: '#6FB52C',
      ultraLight: '#E0EDD3',
    },
    secondary: {
      main: '#000000',
      light: '#575757',
      dark: '#E0E0E0',
    },
    info: {
      main: '#01579B',
      light: '#BFE3F6',
      contrastText: '#01579B',
    },
    success: {
      main: '#66bb6a',
      light: '#E0EDD3',
      contrastText: '#14884D',
      ultraLight: '#2e7d321f',
    },
    warning: {
      main: '#DF651E',
      light: '#FFE0B2',
      contrastText: '#DF651E',
    },
  },
});

// Create a theme instance.
const theme: MuiTheme = createTheme({
  ...palette,
  typography: {
    h1: { fontSize: 96, fontWeight: 500 },
    h2: { fontSize: 60, fontWeight: 400 },
    h3: {
      fontSize: 48,
      fontWeight: 700,
      lineHeight: '56px',
      '@media (max-width:1199px)': {
        fontSize: 28,
        lineHeight: '42px',
      },
    },
    h4: {
      fontSize: 34,
      fontWeight: 600,
      lineHeight: '42px',
      '@media (max-width:1199px)': {
        fontSize: 20,
        lineHeight: '30px',
      },
    },
    h5: {
      fontSize: 29,
      lineHeight: '38px',
      fontWeight: 500,
      '@media (max-width:1199px)': {
        fontSize: 18,
        lineHeight: '24px',
      },
    },
    h6: {
      fontSize: 20,
      lineHeight: '32px',
      fontWeight: 600,
      '@media (max-width:1199px)': {
        fontSize: 16,
        lineHeight: '24px',
      },
    },
    overline: { fontSize: 12, fontWeight: 400 },
    caption: { fontSize: 12, fontWeight: 400 },
    subtitle1: { fontSize: 16, fontWeight: 700 },
    subtitle2: { fontSize: 14, fontWeight: 700 },
    body1: { fontSize: 16, fontWeight: 500 },
    body2: { fontSize: 14, fontWeight: 500, color: '#575757' },
    fontFamily: [
      'Quicksand',
      'Roboto',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  components: {
    MuiAlert: {
      styleOverrides: {
        filledWarning: {
          color: palette.palette.warning.main,
          backgroundColor: palette.palette.warning.light,
        },

        filledError: {
          color: palette.palette.error.contrastText,
          backgroundColor: palette.palette.error.light,
        },
        filledSuccess: {
          color: palette.palette.success.contrastText,
          backgroundColor: palette.palette.success.light,
        },
        filledInfo: {
          color: palette.palette.info.main,
          backgroundColor: palette.palette.info.light,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#FAFAFA',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'rgba(111, 181, 44, 0.08)',
            color: '#158E50',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#ffffff',
          borderRadius: 12,
          boxShadow: '0px 0px 5px 0px rgba(141, 141, 141, 0.13)',
          '&:hover': {
            boxShadow:
              '0px 14px 55px rgba(0, 0, 0, 0.08), 0px 5px 17px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.03)',
          },
          '.MuiCardActionArea-focusHighlight': {
            background: 'transparent',
          },
          '.MuiCardHeader-root': {
            background: 'transparent',
          },
        },
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          marginTop: 'auto',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: '#3C3C3C',
        },
      },
    },
  },
});

const emotionTheme: EmotionTheme = {
  ...theme,
};

export default emotionTheme;
